/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformLogsResponse {
    getFixupPrototypeFunction() { return PlatformLogsResponse.fixupPrototype; }

    static newInstance(model: Partial<PlatformLogsResponse>): PlatformLogsResponse {
        let obj = Object.assign(new PlatformLogsResponse(), model);
        PlatformLogsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformLogsResponse>): PlatformLogsResponse {
        if (!model) return null;
        return PlatformLogsResponse.newInstance(<PlatformLogsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformLogsResponse) {
        if (!obj) return;

        models.PlatformLogsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformLogsResponse): boolean {
        Object.setPrototypeOf(obj, PlatformLogsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Additional information about the log submission
     */
    message: string;

}
